import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_treatment_execution_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  treatment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_line_guid: fromDatatype.GuidDataFieldInterface;
  treatment_status: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_dgmkt_treatment_execution_hdr_RowClass
  implements bl_dgmkt_treatment_execution_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  treatment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_line_guid: fromDatatype.GuidDataFieldInterface;
  treatment_status: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
